import React from "react";
import useModal from "../../../hook/useModal";
import { useState } from "react";
import LanguageSelect from "../LanguageSelect";

const ExportMemory = props => {
    const [show, hide, renderModal, modalEvent] = useModal();
    const [languages, setLanguages] = useState([]);

    modalEvent.onHide = () => setLanguages([]);

    const formattedLangs = languages.map((el, idx) => 'languages[' + idx + ']=' + el).join('&');

    return (
        <React.Fragment>
            <button className={"button button--memory " + props.className} onClick={show}>Export</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <button className="button button--primary" onClick={e => setLanguages([...languages, ""])}>Add Language</button>
                    </div>

                    {languages.map((lang, index) =>
                        <div className="group">
                            <LanguageSelect onChange={e => {
                                const newLanguages = [...languages];
                                newLanguages[index] = e.target.value;
                                setLanguages(newLanguages);
                            }} value={lang} selected={lang} />
                        </div>
                    )}

                    <a download href={`${window.API_URL}/memory/exportNew.php?memoryID=${props.memoryID + "&" + formattedLangs}`} className="button button--memory">Export</a>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ExportMemory;